export default {"src":"https://cdn.jetlend.ru/_next/static/media/cup.41383ee2.svg","height":23,"width":22,"blurWidth":0,"blurHeight":0};